import React, { Component, useEffect, useState } from 'react'
import {Box, Card, Paper,Grid,Divider, Typography,IconButton,Checkbox, Button} from '@mui/material'
import './css/register.css' 
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import base from './base.json'
import logo from '../src/logo/logo.jpeg'


import { useNavigate,useLocation, Link } from 'react-router-dom';
function Register(props) {
  const navigate = useNavigate()
  const location = useLocation()

  const [showpassword,SetshowPassword] =useState(true);
  const [username,Setusername] =useState("");
  const [password,Setpassword] =useState("");
  const [phone,SetPhone] =useState("");
  const [companyName,SetCompanyName] =useState("");


useEffect(()=>{
 
if(location.pathname==="/"){
//props.cl();
}
},[])




 function login(){
  if(companyName!="" && phone!="" && username!="" && password!=""){
    fetch(`${base.base_url}/property_portal/vendor_portal/builder/registerBuilder`, {
      headers:{
        'authorization': `Bearer ${sessionStorage.getItem('token')}`,
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
                      builder_name: companyName,
                      builder_contact_no: phone,
            
                      builder_email_id: username,
                      builder_login_passcode: password,
            })
  
        }).then(function(response) {
          return response.json();
        })
        .then(async(data)=> {
         if(data.status){
          await sessionStorage.setItem('data',JSON.stringify(data.data))
           window.open("/main","_self")
         }else{
          alert("Authentication failed")
         }
        });


      }else{
        alert("Fill All Fields")
      }
      
  }



  return (
    <div class='rrc'>
 
<div class="register-wrapper">

    <div class="property-info">

      <img src={logo} style={{height:100,width:100,objectFit:'contain'}}/>

        <div class="logo">
            Makaan<span>Media</span>
        </div>

        <h1>Find a place you'll love to call home.</h1>

        <p>
            Create your account and explore premium properties,
            apartments, villas, commercial spaces and investment
            opportunities in one place.
        </p>

        <div class="features">
            <div class="feature">🏠 Premium Properties</div>
            <div class="feature">📍 Prime Locations</div>
            <div class="feature">🔐 Secure Platform</div>
        </div>

    </div>


    <div class="form-section">

        <div class="form-header">
            <h2>Create Account</h2>
            <p>Register to start exploring properties.</p>
        </div>

        <div id="registrationForm">

           
            <div class="form-group">
                <label>Company Name</label>

                <div class="input-box">
                    <span class="icon">👤</span>
                    <input
                        type="text"
                        name="name"
                        onChange={(e)=>SetCompanyName(e.target.value)}
                        placeholder="Enter your full name"
                        required
                    />
                </div>
            </div>


            <div class="form-group">
                <label>Email Address</label>

                <div class="input-box">
                    <span class="icon">✉</span>
                    <input
                        type="email"
                        name="email"
                         onChange={(e)=>Setusername(e.target.value)}
                        placeholder="Enter your email address"
                        required
                    />
                </div>
            </div>


        
            <div class="form-group">
                <label>Phone Number</label>

                <div class="input-box">
                    <span class="icon">📱</span>
                    <input
                        type="tel"
                        name="phone"
                          onChange={(e)=>SetPhone(e.target.value)}
                        placeholder="Enter your phone number"
                        pattern="[0-9]{10}"
                        maxlength="10"
                        required
                    />
                </div>
            </div>


            <div class="form-group">
                <label>Password</label>

                <div class="input-box">
                    <span class="icon">🔒</span>

                    <input
                        type="password"
                        id="password"
                        name="password"
                         onChange={(e)=>Setpassword(e.target.value)}
                        placeholder="Create a password"
                        minlength="6"
                        required
                    />

                    <button
                        type="button"
                        class="password-toggle"
                       
                    >
                        👁
                    </button>
                </div>
            </div>


         
            <div class="terms">
                <input type="checkbox" required />

                <span>
                    I agree to the
                    <a href="#">Terms & Conditions</a>
                    and
                    <a href="#">Privacy Policy</a>.
                </span>
            </div>


        
            <button type="submit"  onClick={login} class="register-btn">
                Create Account →
            </button>

        </div>


        <div class="login-text">
            Already have an account?
            <a href="/login">Login</a>
        </div>

        <div class="security">
            🔒 Your information is protected and securely stored.
        </div>

    </div>

</div>

          </div>
  )
}

export default Register






























